<div [formGroup]="form()" class="item-container" [style.display]="isVisible() ? 'flex' : 'none'">
  <label
    [for]="htmlId()"
    [ngStyle]="getCaptionLeftStyle()"
    [ngClass]="[properties.style.toLowerCase(), 'preserve-newlines']"
    [title]="getCaptionLeftTitle()"
    >{{ properties.inputCaptionLeft }}</label
  >

  <div class="input-container second-column">
    <input
      [formControlName]="formControlId"
      [id]="htmlId()"
      type="text"
      [name]="htmlId()"
      [maxlength]="properties.maxTextLength || null"
      [style]="inputStyle()"
      (input)="onInputChange($event)" />
    @if (properties.inputCaptionRight) {
      <span>{{ properties.inputCaptionRight }}</span>
    }
  </div>
</div>
